<template>
  <div class="row">
    <div class="col-lg-4">
      <div class="sidebar-left w-100">
        <div class="sidebar">
          <div
              class="sidebar-content w-100"
          >
            <!-- Header -->
            <div class="chat-fixed-search w-100">
              <div class="d-flex align-items-center w-100">
                <!-- Search -->
                <b-input-group class="input-group-merge w-100 round">
                  <b-input-group-prepend is-text>
                    <feather-icon
                        icon="SearchIcon"
                        class="text-muted"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                      v-model="searchQuery"
                      placeholder="Поиск..."
                  />
                </b-input-group>
              </div>
            </div>

            <!-- ScrollArea: Chat & Contacts -->
            <vue-perfect-scrollbar
                :settings="perfectScrollbarSettings"
                class="chat-user-list-wrapper list-group w-100 scroll-area"
            >

              <!-- Chats Title -->
              <h4 class="mt-4 chat-list-title">
                Студенты
              </h4>

              <!-- Chats -->
              <ul class="chat-users-list chat-list media-list">
                <li v-for="student in studentsWithGroup"
                    @click="chooseStudent(student.id)"
                    class="chat-info flex-grow-1"
                    :class="{'active': student.id === activeStudent}"
                >
                  <h5 class="mb-0">
                    {{ student.name }} - {{ student.email }}
                  </h5>
                  <p class="card-text text-truncate">
                  </p>
                </li>
              </ul>
            </vue-perfect-scrollbar>
          </div>

        </div>
      </div>
    </div>
    <div v-if="activeStudent" class="col-lg-8">
      <h3 class="mb-2">
        {{students.find(student => student.id === activeStudent).name}}
      </h3>

      <h4>Баланс - {{ studentData.balance.balance }}</h4>
      <h4>Оставшиеся уроки по балансу - {{studentData.leftLessons}} </h4>
      <h4 v-if="studentData.transaction">
        Дата последней транзакции - {{ getFormattedDate(studentData.transaction.created_at) }}
      </h4>
      <h4 v-if="studentData.transaction">
        Сумма последней транзакции - {{ studentData.transaction.amount }}
      </h4>
      <h4>Группы</h4>
      <div v-for="group in studentData.groups">
        <h5>
        Название группы - {{group.name}}
        </h5>
        <h5>
        Учитель - {{group.user.name}}
        </h5>
        <h5>
        Описание - {{group.description}}
        </h5>
      </div>
      <router-link :to="{name: 'admin.payments.inner', params: {id: activeStudent}}">
        Посмотреть списания за уроки
      </router-link>



    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea,
  BInputGroup,
  BInputGroupPrepend
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import WorkingHoursInput from "@/components/TeacherSchedule/WorkingHoursInput";
import {createNamespacedHelpers} from 'vuex'
import CRMApi from '@/api/crm';
import formattedDate from '@/mixins/formattedDate'


const {mapState, mapActions, mapGetters} = createNamespacedHelpers('crm')

export default {
  components: {
    WorkingHoursInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormGroup,
    BInputGroupPrepend,
    BFormInput,
    BInputGroup,
    BButton,
    VuePerfectScrollbar
  },
  mixins: [formattedDate],
  name: "index",
  computed: {
    ...mapState({
      students: state => state.students
    }),
    ...mapGetters(['studentsWithGroup']),
    sortedChosenDays() {
      return this.chosenDays.sort((day1, day2) => {
        if (day1 > day2) {
          return 1
        }
        return -1;
      })
    },
  },
  data() {
    return {
      form: {},
      days: [
        {
          id: 0,
          name: 'Понедельник',
        },
        {
          id: 1,
          name: 'Вторик',
        },
        {
          id: 2,
          name: 'Среда'
        },
        {
          id: 3,
          name: 'Четверг'
        },
        {
          id: 4,
          name: 'Пятница',
        },
        {
          id: 5,
          name: 'Суббота'
        },
        {
          id: 6,
          name: 'Воскресенье'
        }
      ],
      chosenDays: [],
      filledTime: {},
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
      searchQuery: '',
      activeChatContactId: '',
      activeStudent: null,
      studentData: {},
    }
  },
  methods: {
    ...mapActions(['getUsers']),
    chooseStudent(id) {
      const student = this.students.find(teacher => teacher.id === id)

      CRMApi.getStudent(student.id)
        .then(res => {
          this.studentData = res.data;
          this.activeStudent = student.id
        })
        .catch(err => {
          this.$bvToast.toast('Please try again later', {
            title: `Oops! Something went wrong...`,
            variant: 'danger',
            solid: true,
          })
        })
    }
  },
  created() {
    this.getUsers();
  }
}
</script>

<style lang="scss" scoped>
.chat-users-list {
  height: 80vh;
  padding-left: 0;
  list-style-type: none;

  .chat-info {
    padding: 10px;
    cursor: pointer;
    &.active{
      background: #ffbd3b;
      h5{
        color: #fff;
      }
    }
  }
}

.dark-layout {
  .chat-fixed-search {
    background-color: #283046;
  }

  .chat-user-list-wrapper {
    background-color: #283046;
  }
}
</style>
